import { render, staticRenderFns } from "./BussinessLoyaltyCard.vue?vue&type=template&id=e269a908&"
import script from "./BussinessLoyaltyCard.vue?vue&type=script&lang=js&"
export * from "./BussinessLoyaltyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports